import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconMakeScreenShot = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M33.6,31.9H2.4V4.1h31.2V31.9z M4.2,30.1h27.6V5.9H4.2V30.1z"/>
      <path d="M30.2,26.2H5.8V7.8h24.5V26.2z M7.6,24.4h20.9V9.6H7.6V24.4z"/>
    </SvgIcon>
  );
};

IconMakeScreenShot.displayName = 'IconMakeScreenShot';
IconMakeScreenShot.muiName = 'SvgIcon';

export default IconMakeScreenShot;



// WEBPACK FOOTER //
// ./src/components/Icons/IconMakeScreenShot.js